/* @flow */
// typecheck: ignore file
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import Overlay from 'components/Overlay.jsx';

import './styles/OverlayLoading.scss';

function OverlayLoading() {
  return (
    <Overlay className="OverlayLoading">
      <Glyph name="gear" size="xxxlarge" />
    </Overlay>
  );
}

export default OverlayLoading;



// WEBPACK FOOTER //
// ./src/components/OverlayLoading.jsx